import React from 'react'
import { useNavigate } from 'react-router-dom';
import Button from '../../shared/button/button';
import { IMAGE_DEFAULT_ERROR_BOUNDARY } from '@/main/services/constants';
import { getTranslateByKey } from '@/main/services/utils';
import { RoutesConstants } from '@/main/routes/routesConstants';
import * as S from './styles';

function LayoutErrorScreen() {
  const navigate = useNavigate();

  function handleClickBackToHome(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    e.stopPropagation();
    navigate(RoutesConstants.home)
  }
  const messageError = getTranslateByKey('information.anUnexpectedErrorOccurredPleaseTryAgainLater', true)

  return (
    <S.Container>
      <S.ImageError src={IMAGE_DEFAULT_ERROR_BOUNDARY} alt={messageError} />
      <S.MessageError>{messageError}</S.MessageError>
      <Button
        id='id-errorScreen-btn-home'
        type='button'
        onClick={handleClickBackToHome}
      >
        {getTranslateByKey('information.backToHome')}
      </Button>
    </S.Container>
  )
}

export default LayoutErrorScreen